"use client"

import NextLink, { useLinkStatus } from "next/link"

// import { useProgressBar } from "@/components/progress-bar"
import { useEffect, type ComponentProps } from "react"
import { cn } from "@/lib/utils"

export interface LinkProps extends ComponentProps<typeof NextLink> {
  unstyled?: boolean
}

export function Link({ unstyled, className, onNavigate, ...props }: LinkProps) {
  // let progress = useProgressBar()
  // let { pending } = useLinkStatus()
  // useEffect(() => {
  //   if (!pending) {
  //     progress.done()
  //   }
  // }, [pending])

  return (
    <NextLink
      {...props}
      className={cn(
        unstyled
          ? ""
          : "inline-flex items-center justify-center text-base font-medium text-slate-12 underline underline-offset-4 transition-[colors,text-decoration-line,text-underline-offset] hover:underline-offset-[6px] focus-visible:outline-none focus-visible:ring-2 active:underline-offset-[8px] disabled:pointer-events-none disabled:opacity-50",
        className,
      )}
      onNavigate={(e) => {
        onNavigate?.(e)
        // we start navigation here
        // progress.start()
      }}
    />
  )
}
